import validate from "/home/runner/work/web/web/node_modules/.pnpm/nuxt@3.14.159_@parcel+watcher@2.5.0_@types+node@22.8.7_ioredis@5.4.1_magicast@0.3.5_rollup@4._j4egxepaneljta5y3h5vwa52vm/node_modules/nuxt/dist/pages/runtime/validate.js";
import set_45game_45layout_45global from "/home/runner/work/web/web/apps/web/app/middleware/setGameLayout.global.ts";
import user_45global from "/home/runner/work/web/web/apps/web/app/middleware/user.global.ts";
import manifest_45route_45rule from "/home/runner/work/web/web/node_modules/.pnpm/nuxt@3.14.159_@parcel+watcher@2.5.0_@types+node@22.8.7_ioredis@5.4.1_magicast@0.3.5_rollup@4._j4egxepaneljta5y3h5vwa52vm/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  set_45game_45layout_45global,
  user_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/runner/work/web/web/apps/web/app/middleware/auth.ts"),
  guest: () => import("/home/runner/work/web/web/apps/web/app/middleware/guest.ts")
}